import { Selector } from '@ngxs/store';
import { ChatsSelectors } from '../samwin/chats/chats.selectors';
import { EmailBehaviourState } from '../samwin/email/email-behaviour/email-behaviour.state';
import { SamwinLinesState } from '../samwin/samwin-lines/samwin-lines.state';

export class SessionSelectors {
   @Selector([ChatsSelectors.isAnyActiveChats, SamwinLinesState.isSourceLineAssignedOrConnected, EmailBehaviourState.isAnyEmailsInProgress])
   public static isLogoutDisabled(isAnyActiveChats: boolean, isSourceLineAssignedOrConnected: boolean, isAnyEmailsInProgress: boolean) {
      return isAnyActiveChats || isSourceLineAssignedOrConnected || isAnyEmailsInProgress;
   }
}
